import AccountManagementPage from "../../../components/shared/accounts/AccountManagementPage";
import { ADMIN_ACCOUNT_CONFIG } from "../../../constants/accountManagementConfig";

const AdminAccountListPage = () => <AccountManagementPage config={ADMIN_ACCOUNT_CONFIG} />;

export default AdminAccountListPage;
